import { useState } from 'react';

export function GeoSettings() {
  const [probeFreq, setProbeFreq] = useState('6');
  const [p1Threshold, setP1Threshold] = useState('2.0');
  const [p2Threshold, setP2Threshold] = useState('1.3');
  const [p3Threshold, setP3Threshold] = useState('0.8');
  const [autoApply, setAutoApply] = useState(true);

  return (
    <div className="bg-slate-900 border border-slate-800 rounded-xl p-5 space-y-5">
      <h3 className="text-sm font-semibold text-slate-300 uppercase tracking-wider">Geo Settings</h3>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {/* Probe frequency */}
        <div>
          <label className="block text-xs font-semibold text-slate-500 uppercase tracking-wider mb-1.5">
            Probe Frequency
          </label>
          <div className="relative">
            <input
              type="number"
              value={probeFreq}
              onChange={e => setProbeFreq(e.target.value)}
              className="w-full bg-slate-800 border border-slate-700 rounded-lg px-3 py-2 text-sm text-slate-100 focus:outline-none focus:border-blue-500"
            />
            <span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-slate-500">hours</span>
          </div>
        </div>

        {/* Auto-apply */}
        <div>
          <label className="block text-xs font-semibold text-slate-500 uppercase tracking-wider mb-1.5">
            Auto-Apply Changes
          </label>
          <button
            onClick={() => setAutoApply(v => !v)}
            className={`relative w-full py-2 rounded-lg border text-sm font-semibold transition-colors ${
              autoApply
                ? 'border-emerald-500/40 bg-emerald-500/10 text-emerald-400'
                : 'border-slate-700 text-slate-500'
            }`}
          >
            {autoApply ? '✓ Enabled' : 'Disabled'}
          </button>
        </div>
      </div>

      {/* Tier thresholds */}
      <div>
        <label className="block text-xs font-semibold text-slate-500 uppercase tracking-wider mb-2">
          Tier Thresholds (Min ROAS)
        </label>
        <div className="grid grid-cols-3 gap-3">
          {[
            { label: 'P1 Min', value: p1Threshold, set: setP1Threshold, cls: 'text-emerald-400' },
            { label: 'P2 Min', value: p2Threshold, set: setP2Threshold, cls: 'text-blue-400' },
            { label: 'P3 Min', value: p3Threshold, set: setP3Threshold, cls: 'text-amber-400' },
          ].map(({ label, value, set, cls }) => (
            <div key={label}>
              <div className={`text-xs font-bold ${cls} mb-1`}>{label}</div>
              <input
                type="number"
                step="0.1"
                value={value}
                onChange={e => set(e.target.value)}
                className="w-full bg-slate-800 border border-slate-700 rounded-lg px-3 py-2 text-sm text-slate-100 focus:outline-none focus:border-blue-500"
              />
            </div>
          ))}
        </div>
        <p className="text-xs text-slate-600 mt-2">States below P3 min ROAS are automatically Excluded</p>
      </div>

      <button className="w-full py-2 bg-blue-600 hover:bg-blue-500 rounded-lg text-sm font-semibold text-white transition-colors">
        Save Settings
      </button>
    </div>
  );
}
